// قطعات مصرفی خودرو (ریز یک تعمیر)
import React, { useState, useEffect } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { ExcelButton } from '../../components/excel';
import { useFormButtons } from '../../utils/vbPerms';
import {
  API, toFa, fmtAmt, Grid, Field, TextIn, Lookup, Modal, DeleteDialog, MsgDialog, excelCols,
} from './carsShared';

const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL'];
const num = v => Number(String(v ?? '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/,/g, '')) || 0;
const blank = () => ({ goods: { id: 0, title: '' }, quantity: '', price: '' });

export default function CarRepairPieces({ user, onBack, repairId, title = '' }) {
  const fb = useFormButtons('FRMCARREPAIRPIECES', BUTTONS);
  const [data, setData] = useState({ data: [], columns: [], total_price: 0 });
  const [sel, setSel] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(blank());
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    const j = await API(`/repair-pieces/?repair_id=${repairId}`);
    setLoading(false);
    if (j.ok) setData(j); else setErr(j.msg);
  };
  useEffect(() => { if (fb.open) load(); }, [fb.open, repairId]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const save = async () => {
    setErr('');
    const body = JSON.stringify({ repair_id: repairId, goods_id: form.goods.id, quantity: form.quantity, price: form.price });
    const j = modal === 'new'
      ? await API('/repair-pieces/create/', { method: 'POST', body })
      : await API(`/repair-pieces/${sel.CarRepairPiecesId}/update/`, { method: 'PUT', body });
    if (!j.ok) { setErr(j.msg); return; }
    setModal(null); load();
  };
  const doDelete = async () => {
    setModal(null);
    const j = await API(`/repair-pieces/${sel.CarRepairPiecesId}/delete/`, { method: 'DELETE' });
    if (!j.ok) setMsg(j.msg); else { setSel(null); load(); }
  };
  const has = !!sel;

  const toolbar = fb.open ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={() => { setForm(blank()); setErr(''); setModal('new'); }} style={ui.btnNew}>＋ جدید</button>}
        {fb.can('BTNEDIT') && <button disabled={!has} onClick={() => {
          setForm({ goods: { id: sel.GoodsId, title: sel['نام قطعه'] || '' }, quantity: sel['تعداد'] ?? '', price: sel['فی'] ?? '' });
          setErr(''); setModal('edit');
        }} style={{ ...ui.btnEdit, opacity: has ? 1 : 0.4 }}>✎ ویرایش</button>}
        {fb.can('BTNDELETE') && <button disabled={!has} onClick={() => setModal('delete')} style={{ ...ui.btnDel, opacity: has ? 1 : 0.4 }}>✕ حذف</button>}
      </div>
      {loading && <span>⏳</span>}
      <div style={{ fontSize: '13px', fontWeight: 700, color: '#1a2f50', alignSelf: 'center' }}>جمع کل: {fmtAmt(data.total_price)}</div>
      <ExcelButton title="قطعات مصرفی خودرو" subtitle={title} columns={excelCols(data.columns, data.data)} rows={data.data} />
    </>
  ) : null;

  return (
    <>
      <ListPage user={user} onBack={onBack} title={`قطعات مصرفی خودرو ${title}`} subtitle="تدارکات — سامانه ارجان" toolbar={toolbar} error={!modal ? err : ''}>
        <Grid columns={data.columns} rows={data.data} rowKey="CarRepairPiecesId" selectedKey={sel?.CarRepairPiecesId} onSelect={setSel} moneyCols={['فی', 'جمع']} />
      </ListPage>
      {(modal === 'new' || modal === 'edit') && (
        <Modal title={modal === 'new' ? '＋ قطعه جدید' : '✎ ویرایش قطعه'} onClose={() => setModal(null)} width="620px"
          footer={<>
            <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>
            {fb.can('BTNOK') && fb.can(modal === 'new' ? 'BTNNEW' : 'BTNEDIT') && <button onClick={save} style={ui.btnSave}>ثبت</button>}
          </>}>
          {err && <div style={ui.errBox}>⚠️ {err}</div>}
          <div style={ui.row}>
            <Field label="نام قطعه" flex={2}><Lookup path="/repair-pieces/lookup/goods/" value={form.goods} onChange={v => F('goods', v)} /></Field>
          </div>
          <div style={ui.row}>
            <Field label="تعداد"><TextIn num value={form.quantity} onChange={v => F('quantity', v)} /></Field>
            <Field label="فی"><TextIn num value={form.price} onChange={v => F('price', v)} /></Field>
            <Field label="جمع"><TextIn num value={toFa(fmtAmt(num(form.quantity) * num(form.price)))} disabled onChange={() => {}} /></Field>
          </div>
          {modal === 'edit' && sel && Number(sel['شماره قبض انبار'] || 0) > 0 && (
            <div style={{ fontSize: '12px', color: '#555' }}>قبض انبار: شماره {toFa(sel['شماره قبض انبار'])} تاریخ {toFa(sel['تاریخ قبض انبار'])}</div>
          )}
        </Modal>
      )}
      {modal === 'delete' && <DeleteDialog onConfirm={doDelete} onCancel={() => setModal(null)} />}
      {msg && <MsgDialog text={msg} onClose={() => setMsg('')} />}
    </>
  );
}
